import moment from "moment";
import { T, TB, APIS } from "../Constants";
import socketIoClient from 'socket.io-client';
import { renderAlert } from '../Components/Modal';

const socketRedux: T.ReduxFn<T.Socket, T.SocketActions> = (socket = null, payload) => {

    if (payload?.type === "CONNECT") {
        if (socket !== null) return socket;
        const newSocket: T.Socket | null = socketIoClient(window.location.origin, { path: APIS.GLOBAL_SOCKET });

        if (newSocket !== null) {
            // Set the defaults callbacks
            newSocket.on("client_log", console.log);
            newSocket.on("no_maintenance", () => localStorage.removeItem("disableLog"));
            // Show an alert to the user
            newSocket.on("alert", params => TB.validObject(params) ? renderAlert(params) : null);

            // Notifications handler
            // The current session user has read all notifications in another session
            newSocket.on("all_notifs_were_read", () => payload?.asyncDispatch?.({ type: "ALL_NOTIF_WERE_READ" }));
            // The current session user has read a notification in another session
            newSocket.on("notif_was_read", (notification: string) => payload?.asyncDispatch?.({ type: "NOTIF_WAS_READ", action: notification }));
            // The current session user has new notifications
            newSocket.on("notifications", (notifications: T.Notification[]) => payload?.asyncDispatch?.({ type: "ADD_NOTIFICATIONS", action: notifications }));
            // Some notifications needs to be deleted
            newSocket.on("del_notifs", (notifications: string[]) => payload?.asyncDispatch?.({ type: "DEL_NOTIFICATIONS", action: notifications || [] }));

            // Force a disconnection of the user
            newSocket.on("forced_disconnect", () => {
                const disableLog = localStorage.getItem("disableLog");
                if (disableLog === null || new Date().getTime() > new Date(disableLog).getTime()) {
                    localStorage.clear();
                    localStorage.setItem("disableLog", moment().add(15, "minute").toISOString());
                    window.location.replace("/logout");
                }
                else if (window.location.pathname !== "/login" && window.location.pathname !== "/logout") window.location.replace("/login");
            });
        }
        return newSocket;
    }
    else if (payload?.type === "DISCONNECT") {
        if (socket !== null) socket.disconnect();
        return null;
    }
    // Allow to fire an emit event from other reducers
    else if (payload?.type === "SOCKET_EMIT") {
        if (payload?.action?.event) socket?.emit?.(payload.action.event, payload.action.params);
        return socket;
    }
    else return socket;
}

export default socketRedux;

export const CONNECT_SOCKET: T.ReduxDispatch<T.SocketActions> = () => ({ type: "CONNECT" });
export const DISCONNECT_SOCKET: T.ReduxDispatch<T.SocketActions> = () => ({ type: "DISCONNECT" });